import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center text-[#5C5853] text-sm tracking-[0.2em] uppercase">
                Loading
            </div>
        );
    }
    if (!user || user.role !== "admin") {
        return <Navigate to="/admin/login" replace />;
    }
    return children;
}
